// utils/GoogleAnalytics.js
//https://vanja.gavric.org/blog/integrate-google-analytics-with-react-router-v4/
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga'
import { Route } from 'react-router-dom'

import '../config.js';

class GoogleAnalytics extends Component {
    componentDidMount () {
        this.logPageChange(
            this.props.location.pathname,
            this.props.location.search
        )
    }

    componentDidUpdate ({ location: prevLocation }) {
        const { location: { pathname, search } } = this.props
        const isDifferentPathname = pathname !== prevLocation.pathname
        const isDifferentSearch = search !== prevLocation.search

        if (isDifferentPathname || isDifferentSearch) {
            this.logPageChange(pathname, search)
        }
    }

    logPageChange (pathname, search = '') {
        let page = pathname + search
        const { location } = window
        if (page.startsWith('/search')) {
            var qObj = page.split('?')[1].split(';').reduce( function(p,n){ var kv = n.split('='); p[kv[0]] = kv[1]; return p; }, {} );
            this.logEvent('Search', qObj.q)
            page = '/search';
        }
        console.log('log page:', page);

        ReactGA.set({
            page,
            location: `${location.origin}${page}`,
            ...this.props.options
            });

        ReactGA.pageview(page)
    }

    logEvent (category, action) {
        console.log('log event:', category, '*', action);
            ReactGA.event(
                {
                    'category': category,
                    'action': action
                }
            );
    }

    render () {
        return null
    }
}

GoogleAnalytics.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string
  }).isRequired,
  options: PropTypes.object
}

const RouteTracker = () =>
  <Route component={GoogleAnalytics} />

const init = (options = {}) => {
  const isGAEnabled = !!global.GA_TRACKING_ID
  if (isGAEnabled) {
    ReactGA.initialize(
      global.GA_TRACKING_ID, {
        ...options
      }
    )
  }
  return isGAEnabled
}

export default {
  GoogleAnalytics,
  RouteTracker,
  init
}